import { render } from "./GlobalFilters.vue?vue&type=template&id=0f4f377a&scoped=true"
import script from "./GlobalFilters.vue?vue&type=script&lang=js"
export * from "./GlobalFilters.vue?vue&type=script&lang=js"

import "./GlobalFilters.vue?vue&type=style&index=0&id=0f4f377a&lang=css"
import "./GlobalFilters.vue?vue&type=style&index=1&id=0f4f377a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4f377a"]])

export default __exports__